module.exports = __webpack_public_path__ + "static/img/403.05bc54f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layout/layout/error-page/403.png
// module id = z+dF
// module chunks = 7